export const Contact = [
  {
    id: "1",
    enable: 1,
    code: "CT001",
    name: "Strathern Park",
    company: "C002",
  },
  {
    id: "2",
    enable: 1,
    code: "CT002",
    name: "Lorem Ipsum",
    company: "C001",
  },
  {
    id: "3",
    enable: 1,
    code: "CT003",
    name: "Atque Corrupti",
    company: "C001",
  },
  {
    id: "4",
    enable: 1,
    code: "CT004",
    name: "Occaecati Cupiditate",
    company: "C002",
  },
  {
    id: "5",
    enable: 1,
    code: "CT005",
    name: "Laborum Dolorum",
    company: "C001",
  },
];
